var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "30.000002px",
    viewBox: "0 0 53 30.000002",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L53 0L53 30L0 30L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GooglePay",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L53 0L53 30L0 30L0 0Z",
    id: "GooglePay",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3934 17.2118L25.3934 23.3666L23.4683 23.3666L23.4683 8.14487L28.4734 8.14487C29.6927 8.14487 30.8477 8.60814 31.746 9.4685C32.6444 10.2627 33.0936 11.454 33.0936 12.7114C33.0936 13.9689 32.6444 15.094 31.746 15.9543C30.8477 16.8147 29.7568 17.278 28.4734 17.278L25.3934 17.2118L25.3934 17.2118L25.3934 17.2118ZM25.3934 9.99801L25.3934 15.2925L28.6019 15.2925C29.3077 15.2925 30.0136 15.0278 30.4627 14.4984C31.4895 13.5056 31.4895 11.8511 30.527 10.8584C30.527 10.8584 30.4627 10.7922 30.4627 10.7922C29.9494 10.2627 29.3077 9.93184 28.6019 9.99801L25.3934 9.99801L25.3934 9.99801L25.3934 9.99801Z",
    id: "Shape",
    fill: "#5F6368",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5216 12.6454C38.9333 12.6454 40.0241 13.0425 40.8583 13.8366C41.6925 14.6308 42.0775 15.6897 42.0775 17.0133L42.0775 23.3668L40.2808 23.3668L40.2808 21.9108L40.2166 21.9108C39.4466 23.102 38.3558 23.6977 37.0723 23.6977C35.9815 23.6977 35.019 23.3668 34.249 22.705C33.5431 22.0431 33.0939 21.1167 33.0939 20.1239C33.0939 19.065 33.4789 18.2046 34.249 17.5428C35.019 16.881 36.1099 16.6163 37.3932 16.6163C38.5482 16.6163 39.4466 16.8148 40.1525 17.2781L40.1525 16.8148C40.1525 16.153 39.8958 15.4912 39.3824 15.0941C38.8691 14.6308 38.2274 14.3661 37.5216 14.3661C36.4307 14.3661 35.5965 14.8294 35.019 15.7559L33.3506 14.697C34.3773 13.3072 35.7248 12.6454 37.5216 12.6454L37.5216 12.6454ZM35.0832 20.1903C35.0832 20.7197 35.3399 21.183 35.7249 21.4477C36.1741 21.7786 36.6874 21.9771 37.2008 21.9771C37.9708 21.9771 38.7408 21.6462 39.3183 21.0506C39.96 20.455 40.2809 19.727 40.2809 18.9328C39.7033 18.4695 38.8691 18.2048 37.7783 18.2048C37.0083 18.2048 36.3666 18.4033 35.8532 18.8004C35.3399 19.1313 35.0832 19.5946 35.0832 20.1903L35.0832 20.1903Z",
    id: "Shape",
    fill: "#5F6368",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4734 12.9763L46.1206 28L44.1954 28L46.5697 22.7715L42.3987 13.0425L44.4521 13.0425L47.4681 20.5212L47.5323 20.5212L50.4841 13.0425L52.4734 13.0425L52.4734 12.9763Z",
    id: "Shape",
    fill: "#5F6368",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7571 15.8884C17.7571 15.2927 17.693 14.6971 17.6288 14.1014L9.60746 14.1014L9.60746 17.4768L14.1636 17.4768C13.9711 18.5357 13.3935 19.5285 12.4951 20.1241L12.4951 22.3082L15.2545 22.3082C16.8587 20.786 17.7571 18.5357 17.7571 15.8884L17.7571 15.8884Z",
    id: "Shape",
    fill: "#4285F4",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60747 24.4261C11.9176 24.4261 13.8427 23.6319 15.2545 22.3082L12.4951 20.1241C11.7251 20.6536 10.7625 20.9845 9.60747 20.9845C7.42567 20.9845 5.50055 19.4623 4.85884 17.3444L2.03533 17.3444L2.03533 19.5947C3.51126 22.5729 6.39893 24.4261 9.60747 24.4261L9.60747 24.4261Z",
    id: "Shape",
    fill: "#34A853",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85884 17.3444C4.47381 16.2855 4.47381 15.0942 4.85884 13.969L4.85884 11.7188L2.03533 11.7188C0.816085 14.1676 0.816085 17.0797 2.03533 19.5947L4.85884 17.3444L4.85884 17.3444Z",
    id: "Shape",
    fill: "#FBBC04",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60747 10.3951C10.8267 10.3951 11.9818 10.8584 12.8802 11.7188L12.8802 11.7188L15.3187 9.20381C13.7786 7.74777 11.7251 6.88738 9.67164 6.95356C6.4631 6.95356 3.51125 8.80671 2.0995 11.785L4.92301 14.0352C5.50055 11.9173 7.42566 10.3951 9.60747 10.3951L9.60747 10.3951Z",
    id: "Shape",
    fill: "#EA4335",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/GooglePay.3249a8edb78e64718d7799bbdc5f916c.svg";
export { ForwardRef as ReactComponent };